export class openAuthenticationconnector {
  cid: string;

}
